import React from "react";
import styled from "styled-components";
import URI from "urijs";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
const StyledA = styled.a`
  &:hover {
    text-decoration: none;
  }
`;
const StyledButton = styled(Button)`
  margin-top: 1em;
  display: block;
  cursor: pointer;
  width: 100%;
`;
const getAuthUrl = ({ authorizationEndpoint, nonce, clientId, redirectUri }) => {
  const url = URI(authorizationEndpoint).addSearch({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state: nonce.state,
    nonce: nonce.state
  });
  return url.toString();
};
function OidcGenericLoginLink({ configuration, nonce }) {
  const { t } = useTranslation("enterprise_authentication");
  const {
    oauth_auth_url: authorizationEndpoint,
    oauth_client_id: clientId,
    oauth_callback_url: redirectUri,
    oauth_title: title
  } = configuration;
  const loginUrl = getAuthUrl({
    authorizationEndpoint,
    nonce,
    clientId,
    redirectUri
  });
  return /* @__PURE__ */ React.createElement(StyledA, { href: loginUrl }, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "info" }, t("oidc.oidc_generic_login_link.login_with", { title })));
}
export default OidcGenericLoginLink;
